module.exports = __webpack_public_path__ + "../static/img/placeholder_hover.b41c1999.jpg";